import { i18n } from '@/plugins/i18n'

const fields = [
    {
        key: 'non_hash_id',
        label: i18n.t('attributes.id'),
        sorter: true,
        _style: 'width:10%'
    },
    {
        key: 'name',
        label: i18n.t('store.name'),
        sorter: true,
        _style: 'width:25%;min-width:190px;'
    },
    {
        key: 'category',
        label: i18n.t('category._'),
        sorter: false,
    },
    {
        key: 'status',
        label: i18n.t('store.status'),
        sorter: false,
        _style: 'width:10%',
        _classes: 'text-center align-middle',
    },
    {
        key: 'activatedAt',
        label: i18n.t('store.activated_at'),
        sorter: false,
        _classes: 'text-center align-middle',
    },
    {
        key: 'members_count',
        label: i18n.t('store.publishers_count'),
        sorter: false,
        _style: 'width:10%',
        _classes: 'text-center align-middle'
    },
    {
        key: 'cookie_lifetime',
        label: i18n.t('store.cookie_lifetime') + '(' +i18n.t('time.day')+ ')',
        sorter: false,
        _style: 'width:15%',
        _classes: 'text-center align-middle'
    },
    {
        key: 'conversion_locked_after',
        label: i18n.t('store.conversion_locked_after') + '(' +i18n.t('time.day')+ ')',
        sorter: false,
        _style: 'width:13%',
        _classes: 'text-center align-middle'
    },
    {
        key: 'epc',
        label: i18n.t('store.avg_epc') + '(' +i18n.t('rial')+ ')',
        sorter: false,
        _classes: 'text-center align-middle'
    },
    {
        key: 'avgCommission',
        label: i18n.t('store.avg_commission') + '(' +i18n.t('rial')+ ')',
        sorter: false,
        _classes: 'text-center align-middle'
    },
    {
        key: 'invalidClickRate',
        label: i18n.t('store.invalid_click_rate'),
        sorter: false,
        _classes: 'text-center alieng-middle'
    },
    {
        key: 'accessId',
        label: i18n.t('store.access_id'),
        policies: {
            store: ['api']
        },
        sorter: false,
        _style: 'width:10%',
        _classes: 'text-center align-middle'
    },
    {
        key: 'actions',
        label: i18n.t('actions'),
        sorter: false,
        _style: 'width:15%;min-width:150px;',
        _classes: 'text-center align-middle'
    }
]

export default fields

export const sorts = [
    {
        label: i18n.t('sorter.favorites'),
        value: {
            direction: 'desc',
            column: 'favorites'
        },
        rules: {
            store: 'join',
        },
    },
    {
        label: i18n.t('sorter.desc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'desc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.asc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'asc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.desc', {attr: i18n.t('store.avg_epc')}),
        value: {
            direction: 'desc',
            column: 'epc'
        }
    },
    {
        label: i18n.t('sorter.desc', {attr: i18n.t('store.avg_commission')}),
        value: {
            direction: 'desc',
            column: 'avg_commission'
        }
    },
    {
        label: i18n.t('sorter.desc', {attr: i18n.t('store.invalid_click_rate')}),
        value: {
            direction: 'desc',
            column: 'invalid_click_rate'
        },
        rules: {
            store: 'create_any_or_group',
        },
    },
    {
        label: i18n.t('sorter.asc', {attr: i18n.t('store.invalid_click_rate')}),
        value: {
            direction: 'asc',
            column: 'invalid_click_rate'
        },
        rules: {
            store: 'create_any_or_group',
        },
    },
]